<template>
  <router-link to="/home">
    <svg-icon icon-class="matr1x_fire_logo" class-name="logo-svg"></svg-icon>
  </router-link>
</template>

<script>
export default {
  name: "",
  data() {
    return {}
  },
  props: {},
  components: {},
  computed: {},
  mounted() { },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>